import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { redirectActions } from '../../entities/history';
import { useWindowWidth } from '@distribute/frontend/utils';

export const useMobileRedirect = () => {
  const dispatch = useDispatch();

  const { isTablet, isMobile } = useWindowWidth();

  useEffect(() => {
    if (isTablet || isMobile) {
      dispatch(redirectActions.toWorkspace());
    }
  }, [isTablet, isMobile, dispatch]);
};
